module.exports = __webpack_public_path__ + "img/nt115-00-81-1.asm.a7b13959.jpg";